var render = function render(){var _vm=this,_c=_vm._self._c;return _c('aside',{staticClass:"sidebar-left"},[_c('CompaniesList')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }